import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgGridIconSecondary from './svgs/GridIconSecondary.js';
import SvgGridIcon from './svgs/GridIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var gridIcon = (props => useIcon(SvgGridIcon, SvgGridIconSecondary, props));

export { gridIcon as default };
